import favoritesIcon from '@/assets/home-filter/favorites.svg';
import lastMinuteIcon from '@/assets/home-filter/last-minute.svg';
import liveIcon from '@/assets/home-filter/live.svg';
import prematchIcon from '@/assets/home-filter/prematch.svg';
import todayIcon from '@/assets/home-filter/today.svg';
import topEventsIcon from '@/assets/home-filter/top-events.svg';

export type HomeFilterId =
  | 'live'
  | 'prematch'
  | 'favorites'
  | 'top-events'
  | 'today'
  | 'last-minute';

/** Which first chip to show — Live on sports pages, Prematch on live pages. */
export type HomeFilterMenuContext = 'prematch' | 'live';

export interface HomeFilterMenuItem {
  id: HomeFilterId;
  label: string;
  /** Legacy WebsiteTranslates key for `t()`. */
  translateKey: string;
  /** Figma HomeFilterMenu icon asset (16×16). */
  icon: string;
}

export interface HomeFilterMenuItemsOptions {
  /** Show Favourites chip only when the player has prematch favorites. */
  showFavorites?: boolean;
}

const LIVE_ITEM: HomeFilterMenuItem = {
  id: 'live',
  label: 'Live',
  translateKey: 'LiveBetting',
  icon: liveIcon,
};

const PREMATCH_ITEM: HomeFilterMenuItem = {
  id: 'prematch',
  label: 'Prematch',
  translateKey: 'Prematch',
  icon: prematchIcon,
};

const FAVORITES_ITEM: HomeFilterMenuItem = {
  id: 'favorites',
  label: 'Favourites',
  translateKey: 'Favourites',
  icon: favoritesIcon,
};

const SHARED_ITEMS: readonly HomeFilterMenuItem[] = [
  { id: 'top-events', label: 'Top Events', translateKey: 'Topevents', icon: topEventsIcon },
  { id: 'today', label: 'Today', translateKey: 'Today', icon: todayIcon },
  { id: 'last-minute', label: 'Last Minute', translateKey: 'Lastminute', icon: lastMinuteIcon },
];

function sharedItems(showFavorites: boolean): readonly HomeFilterMenuItem[] {
  return showFavorites ? [FAVORITES_ITEM, ...SHARED_ITEMS] : SHARED_ITEMS;
}

/** Figma HomeFilterMenu — Live | Top Events | Today | Last Minute (Favourites optional). */
export const HOME_FILTER_MENU_ITEMS: readonly HomeFilterMenuItem[] = [
  LIVE_ITEM,
  ...SHARED_ITEMS,
];

/** Live pages — Prematch replaces Live as the mode switcher. */
export const HOME_FILTER_MENU_ITEMS_LIVE: readonly HomeFilterMenuItem[] = [
  PREMATCH_ITEM,
  ...SHARED_ITEMS,
];

export function homeFilterMenuItems(
  context: HomeFilterMenuContext = 'prematch',
  options: HomeFilterMenuItemsOptions = {},
): readonly HomeFilterMenuItem[] {
  const shared = sharedItems(Boolean(options.showFavorites));
  return context === 'live' ? [PREMATCH_ITEM, ...shared] : [LIVE_ITEM, ...shared];
}
